'use client';

import { SessionProvider } from 'next-auth/react';
import FirebaseAuthSync from '@/components/providers/firebase-auth-sync';

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      {children}
      {/* Here (root) rather than only in (main)'s ClientWrapper so it also
          runs on login/exit/end pages — that's where it signs the browser's
          Firebase user out after a NextAuth logout. */}
      <FirebaseAuthSync />
    </SessionProvider>
  );
}
